<template>
  <div class="console-container">
    <div class="breadcrumbs mb-40">
      <div class="breadcrumb">
        <router-link to="/console/app-list">
          <div class="btn-back">
            <el-icon>
              <ArrowLeft />
            </el-icon>
            {{ $t('breadcrumb.back') }}
          </div>
        </router-link>
      </div>
    </div>
    <div class="sub-menu-title">
      {{ $t('store_list.title') }}
      <el-button
        type="success"
        class="btn-store-list"
        :disabled="disabledCreate"
        @click="createPairingStore()">
        Next
      </el-button>
    </div>
    <div class="store-list-box">
      <el-skeleton :loading="loading" animated>
        <template #template>
          <loading-store />
        </template>
        <template #default>
          <div v-if="paramListStore.total > 0">
            <el-row :gutter="20">
              <el-col v-for="(items, key) in dataListStore" :key="key" :sm="12" :md="12" :lg="6" :xl="6" class="store-list-col">
                <div class="store-list-sub">
                  <div class="content-box">
                    <div class="flex-container align-center">
                      <el-avatar class="mr-6" :size="50" :src="items.logo_xs" />
                      <span class="color-black font-16">{{ items.name }}</span>
                    </div>
                  </div>
                  <div class="content-box">
                    <el-radio
                      v-model="selectedStore"
                      :label="items.url_id"
                      class="mt-4"
                      @change="handleSelectedStore(items.url_id)"
                    />
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row justify="center">
              <pagination
                :total="paramListStore.total"
                :page="paramListStore.page"
                :page-size="paramListStore.per_page"
                @current-change="changePage"
                class="mt-8"
              />
            </el-row>
          </div>
          <div v-else>
            <el-empty
              description="Data not available"
              style="background: #f4f4f4;border-radius: 8px;"
            />
          </div>
        </template>
      </el-skeleton>
    </div>
  </div>
</template>

<script setup>
import { listStore } from '@/api/endpoints/catalog/authOlsera.js'
import { onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import LoadingStore from '@/components/layout/LoadingStore.vue'
import Pagination from '@/components/layout/Pagination.vue'
import { ArrowLeft } from '@element-plus/icons-vue'

const router = useRouter()
const loading = ref(false)
const dataListStore = ref([])
const disabledCreate = ref(true)
const selectedStore = ref(null)
const paramListStore = reactive({
  page: 1,
  per_page: 24,
  total: 0
})

onMounted(() => {
  getDataListStore()
})

const getDataListStore = () => {
  loading.value = true
  listStore(paramListStore).then((response) => {
    dataListStore.value = response.data.data
    paramListStore.total = response.data.meta.total
    loading.value = false
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
    loading.value = false
  })
}
const createPairingStore = () => {
  router.push({
    path: '/create-app',
    query: { store: selectedStore.value }
  })
}
const handleSelectedStore = (payload) => {
  if (selectedStore.value) {
    disabledCreate.value = false
  } else {
    disabledCreate.value = true
  }
}
const changePage = (page) => {
  paramListStore.page = page
  getDataListStore()
}
</script>
